//import { useStudentSocket } from './../../Providers/StudentSocketProvider'
//import { StudentSocketProvider } from './../../Providers/StudentSocketProvider'

import { useNavigate } from 'react-router'
import { CreditsText } from './CreditsText'


const Credits = () => {
    //const { status, isReady } = useStudentSocket()

    const navigate = useNavigate()


    return (
        <>
            <footer>
                <p className='Credits__Text--Center Credits__SpaceUp Fonts--PlusJakartaSans'><CreditsText /></p>
                <div className='d-flex flex-wrap justify-content-center Fonts--PlusJakartaSans'>
                    <p style={{textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px', marginBottom: '12px' }} onClick={() => navigate('/legals/privacy')}>Aviso de privacidad</p>
                    <p style={{textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px', marginBottom: '12px', marginLeft: '16px' }} onClick={() => navigate('/contact')}>Contacto</p>
                </div>
            </footer>

            {/* <small style={{opacity:.6}}>WS Ztudiante: {status} {isReady() ? '✅' : '…'}</small> */}
        </>
    )
}

export { Credits };